
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReadyToMergeMergeRequest"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MergeRequest"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"autoMergeEnabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"shouldRemoveSourceBranch"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"forceRemoveSourceBranch"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"defaultMergeCommitMessage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"defaultSquashCommitMessage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"squash"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"squashOnMerge"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"diffHeadSha"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"userPermissions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeSourceBranch"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"updateMergeRequest"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"targetBranch"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mergeError"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"commitsWithoutMergeCommits"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sha"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"shortId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"message"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"headPipeline"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"path"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"active"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ref"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":504}};
    doc.loc.source = {"body":"fragment ReadyToMergeMergeRequest on MergeRequest {\n  id\n  autoMergeEnabled\n  shouldRemoveSourceBranch\n  forceRemoveSourceBranch\n  defaultMergeCommitMessage\n  defaultSquashCommitMessage\n  squash\n  squashOnMerge\n  diffHeadSha\n  userPermissions {\n    removeSourceBranch\n    updateMergeRequest\n  }\n  targetBranch\n  mergeError\n  commitsWithoutMergeCommits {\n    nodes {\n      id\n      sha\n      shortId\n      title\n      message\n    }\n  }\n  headPipeline {\n    id\n    status\n    path\n    active\n    ref\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["ReadyToMergeMergeRequest"] = oneQuery(doc, "ReadyToMergeMergeRequest");
        
